export const apartmentSetupSelectOptions = [
  {
    name: 'Apartment',
    value: 'Apartment',
  },
  {
    name: 'Hotel',
    value: 'Hotel',
  },
  {
    name: 'House',
    value: 'House',
  },
];

export const repTypeSelectOptions = [
  {
    name: 'Sales Rep',
    value: 'REP',
  },
  {
    name: 'Service Pro',
    value: 'SP',
  },
];

export const apartmentTypeSelectOptions = [
  {
    name: 'Married',
    value: 'Married',
  },
  {
    name: 'Married-Office',
    value: 'Married-Office',
  },
  {
    name: 'Married-Own Apartment',
    value: 'M/OA',
  },
  {
    name: 'Not in Apartments',
    value: 'Not in Apartments',
  },
  {
    name: 'Office Apartment',
    value: 'Office Apartment',
  },
  {
    name: 'Single',
    value: 'Single',
  },
  {
    name: 'Single Female',
    value: 'Single Female',
  },
  {
    name: 'Mixed',
    value: 'Mixed',
  },
];

export const couchSelectOptions = [
  {
    name: 'Yes',
    value: 'Yes',
  },
  {
    name: 'No',
    value: 'No',
  },
];

export const numberOfRoomsSelectOptions = [
  {
    name: '1',
    value: 1,
  },
  {
    name: '2',
    value: 2,
  },
  {
    name: '3',
    value: 3,
  },
  {
    name: '4',
    value: 4,
  },
  {
    name: '5',
    value: 5,
  },
  {
    name: '6',
    value: 6,
  },
  {
    name: '7',
    value: 7,
  },
  {
    name: '8',
    value: 8,
  },
  {
    name: '9',
    value: 9,
  },
  {
    name: '10',
    value: 10,
  },
  {
    name: '11',
    value: 11,
  },
  {
    name: '12',
    value: 12,
  },
  {
    name: '13',
    value: 13,
  },
  {
    name: '14',
    value: 14,
  },
  {
    name: '15',
    value: 15,
  },
];

export const numberOfBedsSelectOptions = [
  {
    name: '1 Bed',
    value: 1,
  },
  {
    name: '2 Beds',
    value: 2,
  },
  {
    name: '3 Beds',
    value: 3,
  },
  {
    name: '4 Beds',
    value: 4,
  },
];

export const furnishedSelectOptions = [
  {
    name: 'Furnished',
    value: 1,
  },
  {
    name: 'Unfurnished',
    value: 0,
  },
];

export const isAddedToRepSelectOptions = [
  {
    name: 'Yes',
    value: 'Yes',
  },
  {
    name: 'No',
    value: 'No',
  },
];

export const defaultSelectOption = [
  { value: '', name: '-- Select --' },
];

export const rentDueSelectOption = [
  { value: 'D', name: 'Daily' },
  { value: 'W', name: 'Weekly' },
  { value: 'M', name: 'Monthly' },
  { value: 'A', name: 'Annually' },
];

export const moveOutNoticeSelectOption = [
  { value: '1', name: 'Yes' },
  { value: '0', name: 'No' },
];
